<div class="bm-debt-collection-balance p-2">
    <div class="flex flex-column gap-2">
        <h3 class="text-2xl font-bold mb-0">Rechnungsübersicht</h3>
        <p-button label="Vorschlag generieren" icon="fa-solid fa-file-search"></p-button>
    </div>
    <div class="balance-content">
        @if (balanceEntries?.length) {
            <div class="ledger mt-4">
                <div *ngFor="let item of balanceEntries"
                     class="ledger-row" [class.text-gray-500]="!item.active">

                    <div class="ledger-left w-full">
                        <div class="title">{{ item.name }}</div>
                    </div>

                    <div class="ledger-right flex justify-content-end gap-2 align-items-center">
                        <span class="font-bold">{{ item.amount != 0 ? '-' : '' }}{{ item.amount | number:'1.2-2' }}
                            €</span>
                        <div>
                            @if (item.removable) {
                                <i
                                        class="pi pi-trash cancel-icon cursor-pointer cursor pointer"
                                        (click)="removeEntry(item)"
                                        pTooltip="Vertrag entfernen">
                                </i>
                            }
                        </div>
                    </div>

                </div>

                <div class="ledger-row total w-full">
                    <div class="w-full flex justify-content-between align-items-center">
                        <span>Total</span>
                        <span class="text-red-500 font-bold">{{ totalBalance != 0 ? '-' : '' }}{{ totalBalance | number:'1.2-2' }}
                            €</span>
                    </div>
                </div>

            </div>
        }
        @if (manualPayments?.length) {
            <div class="ledger mt-4">
                <div *ngFor="let item of manualPayments"
                     class="ledger-row">

                    <div class="ledger-left w-full">
                        <div class="title">{{ item.name }}</div>
                    </div>

                    <div class="ledger-right flex justify-content-end gap-2 align-items-center">
                        <span class="font-bold">{{ item.amount != 0 ? '-' : '' }}{{ item.amount | number:'1.2-2' }}
                            €</span>
                        <div>
                            @if (item.removable) {
                                <i
                                        class="pi pi-trash cancel-icon cursor-pointer cursor pointer"
                                        (click)="removeEntry(item)"
                                        pTooltip="Vertrag entfernen">
                                </i>
                            }
                        </div>
                    </div>

                </div>

                <div class="ledger-row total w-full">
                    <div class="w-full flex justify-content-between align-items-center">
                        <span>Total</span>
                        <span class="text-red-500 font-bold">{{ manualPaymentsTotalBalance != 0 ? '-' : '' }}{{ manualPaymentsTotalBalance | number:'1.2-2' }}
                            €</span>
                    </div>
                </div>

            </div>
        }
        <div class="ledger mt-4">

            <div *ngFor="let contract of dunningData?.contracts" class="ledger-row">
                <div class="ledger-left w-full">
                    <div class="flex justify-content-between align-items-center">
                        <div class="title flex flex-column">
                            <span>{{ contract.identifier }}</span>
                            <span>{{ contract.type }}</span>
                        </div>
                        <div class="title flex flex-column align-items-end gap-2">
                            <span class="text-green-500 font-bold">+{{ contract.dunningAmount | number:'1.2-2' }}
                                €</span>
                            <span>{{ contract.dunningMonths }} MB</span>
                        </div>
                    </div>
                </div>

            </div>

            <div class="ledger-row total w-full">
                <div class="w-full flex justify-content-between align-items-center">
                    <span>Total</span>
                    <span class="text-green-500 font-bold">{{ contractsTotalBalance > 0 ? '+' : '' }}{{ contractsTotalBalance | number:'1.2-2' }}
                        €</span>
                </div>
            </div>

        </div>

        <div class="ledger mt-4 bg-gray-200 flex flex-column border-round-md p-3 gap-3">
            <div>Add subsequent bookings manually</div>
            <p-button label="Add Manually" styleClass="w-full" (click)="openManualPaymentDialog()"></p-button>
        </div>
    </div>
</div>

<bm-manual-payment-dialog
    [(visible)]="showManualPaymentDialog"
    defaultName=""
></bm-manual-payment-dialog>

